// Egyptian governorates list — used by shipping rule + free shipping modals
// when the live governorates query is loading. The redesign matches the
// design source which ships a static list.
export const GOVERNORATES = [
  "Cairo",
  "Giza",
  "Alexandria",
  "Qalyubia",
  "6th of October",
  "Helwan",
  "Shubra El Kheima",
  "Damanhur",
  "Kafr El Dawwar",
  "Mansoura",
  "Tanta",
  "Zagazig",
  "Banha",
  "Damietta",
  "Mit Ghamr",
  "Kafr El Sheikh",
  "El Mahalla El Kubra",
  "Port Said",
  "Ismailia",
  "Suez",
  "North Sinai",
  "South Sinai",
  "Red Sea",
  "Matruh",
  "New Valley",
  "Aswan",
  "Luxor",
  "Sohag",
  "Qena",
  "Asyut",
  "Minya",
  "Beni Suef",
  "Fayoum",
];
